import React from "react";
import { FaLinkedin } from "react-icons/fa";

const LinkedinReg = () => {
  const handleLinkedInLogin = async () => {
    const response = await fetch(
      "https://platinumfuse.v2napi.com/api/oauth/authorize?redirect_url=http://localhost:3000/oauth/callback"
    );

    const data = await response.json();

    

    window.location.href = data.url;
  };

  return (
    <span
      onClick={handleLinkedInLogin}
      className="w-full cursor-pointer md:w-auto bg-blue-700 text-white font-bold py-3 px-[5px] rounded-lg hover:bg-blue-800 transition duration-300 flex items-center justify-center space-x-2  md:px-6"
    >
      <FaLinkedin size={20} />
      <span>Sign up with LinkedIn</span>
    </span>
  );
};

export default LinkedinReg;
